import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Col, Row, Button, Dropdown } from "react-bootstrap";
import { SXModalBase } from "./SXModal";
import { useTranslation } from "react-i18next";
import { openModal, closeModal, selectModalById } from "../../features/ui/uiSlice";
import "../../../i18n";
import { languages } from "../../config/languages";

interface ProjectCreateModalProps {
  isCreateModalOpen: boolean;
}

export const ProjectCreateModal = (props: ProjectCreateModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const handleLanguageSelect = async (langCode: string) => {
    await i18n.changeLanguage(langCode);
  };

  // const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  return (
    <SXModalBase
      header={t("create")}
      show={props.isCreateModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("createModal"));
      }}
      body={
        <Container>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={2}>{t("language")}</Col>
            <Col xs={3}></Col>
          </Row>
          <Row>
            <Col></Col>
            <Col></Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </Container>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("createModal"));
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            id="disclaimerok"
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("createModal"));
            }}
          >
            {t("ok")}
          </Button>
        </>
      }
    />
  );
};
